import { render } from "./template-library.vue?vue&type=template&id=0d8de09d"
import script from "./template-library.vue?vue&type=script&lang=js"
export * from "./template-library.vue?vue&type=script&lang=js"

import "./template-library.vue?vue&type=style&index=0&id=0d8de09d&lang=postcss"
script.render = render

export default script